document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.our-mission-section');
  const container = document.querySelector('.our-mission-sections');
  const lastSection = sections[sections.length - 1];

  const observer = new IntersectionObserver((entries) => {
    // Remove all visible classes first
    sections.forEach(section => section.classList.remove('visible'));

    // Find the entry that is most in view
    let maxRatio = 0;
    let mostVisible = null;
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
        maxRatio = entry.intersectionRatio;
        mostVisible = entry.target;
      }
    });

    // Add visible to the most visible section, if any
    if (mostVisible) {
      mostVisible.classList.add('visible');
    }
  }, { threshold: buildThresholdList() });

  sections.forEach(section => observer.observe(section));

  // Helper to create a fine-grained threshold array
  function buildThresholdList() {
    let thresholds = [];
    for (let i=0; i<=1.0; i+=0.01) {
      thresholds.push(i);
    }
    return thresholds;
  }

  // When you scroll past the end, assign 'relative-section' to the last section
  window.addEventListener('scroll', function() {
    const rect = container.getBoundingClientRect();
    if (rect.bottom < window.innerHeight) {
      // Remove 'visible' from all, add 'relative-section' to last
      sections.forEach(section => section.classList.remove('visible', 'relative-section'));
      lastSection.classList.add('relative-section');
    } else {
      // Remove 'relative-section' from all
      sections.forEach(section => section.classList.remove('relative-section'));
    }
  });
}); 